import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HERO_FALLBACK = "https://static.prod-images.emergentagent.com/jobs/09829b92-385e-4575-aba1-9841550c8b51/images/1027cbbd1c8ca44dc780a7a1da5db05f55f74c1ce533fe0fb3a442529fcbf347.jpeg";

const SIZES = {
  live: { box: "h-[86vh] min-h-[560px] max-h-[900px]", title: "text-5xl sm:text-6xl lg:text-7xl", sub: "text-base sm:text-lg", align: "items-end sm:items-center pb-16 sm:pb-0", pad: "px-5 sm:px-8" },
  mobile: { box: "h-[726px]", title: "text-5xl", sub: "text-base", align: "items-end pb-16", pad: "px-5" },
  desktop: { box: "h-[688px]", title: "text-7xl", sub: "text-lg", align: "items-center", pad: "px-8" },
};

export const HeroBanner = ({ s, image, mode = "live" }) => {
  const z = SIZES[mode];
  const live = mode === "live";
  const anim = (c) => (live ? c : "");
  return (
    <section className={`relative ${z.box} overflow-hidden grain`} data-testid={live ? "home-hero" : `hero-preview-${mode}`}>
      <img src={image || s.hero_image_url || HERO_FALLBACK} alt="Pelletteria BDC-Boutique" fetchpriority="high"
        className={`absolute inset-0 w-full h-full object-cover object-[70%_center] scale-105 ${anim("animate-[rise_1.6s_ease-out_both]")}`} />
      <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-[#39251D]/85 via-[#39251D]/45 to-transparent" />
      <div className={`relative h-full max-w-[1440px] mx-auto ${z.pad} flex ${z.align}`}>
        <div className="max-w-xl">
          <div className={`${anim("rise")} text-[11px] uppercase tracking-[0.3em] text-[#D5B98C] mb-5`}>Pelletteria & accessori</div>
          <h1 data-testid={live ? "hero-title" : undefined} className={`${anim("rise d1")} font-serif ${z.title} text-[#F5F0E8] leading-[0.95] tracking-tight`}>{s.hero_title || "La tradizione da indossare."}</h1>
          <p data-testid={live ? "hero-subtitle" : undefined} className={`${anim("rise d2")} mt-6 ${z.sub} text-[#F5F0E8]/85 max-w-md leading-relaxed`}>{s.hero_subtitle || "Una selezione di pelletteria e accessori, dove stile e tradizione si incontrano."}</p>
          <Link to="/collezione" onClick={live ? undefined : (e) => e.preventDefault()} data-testid={live ? "hero-cta-button" : undefined}
            className={`${anim("rise d3")} group mt-9 inline-flex items-center gap-3 bg-[#F5F0E8] text-[#39251D] px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-[#D5B98C] transition-colors`}>
            {s.hero_cta || "Scopri la collezione"} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
